import { Box } from '@mui/material';
import classNames from 'classnames';
import { getAgeInYearsOrMonths, removeChar } from '../../../../helper';
import DetailsContainer from '../../../order-management/order-view/OrderTabs/TravellerInfo/DetailsContainer';

interface IOtherGuests {
  data: any;
}

export const OtherGuests = (props: IOtherGuests) => {
  const { data } = props;
  return (
    <div className={classNames('order-view--traveller-card card', 'order-view--tabs')}>
      <div className="d-flex flex-wrap">
        {data?.travellers?.map((traveller: any, idx: number) => (
          <div key={traveller.id} className="d-flex align-items-stretch" style={{ width: '50%', minWidth: '300px' }}>
            <div style={{ width: '100%' }}>
              <div id={`traveller_${removeChar(traveller?.id)}_info`} className='card-body pb-6'>
                <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
                  <div className='flex-grow-1'>
                    <div className='d-flex justify-content-between align-items-start'>
                      <div className='d-flex flex-column'>
                        <div className='d-flex align-items-center mb-2'>
                          <div className='symbol symbol-circle symbol-20px overflow-hidden me-2'>
                            <div className='symbol-label fs-7 bg-info text-light'>
                              {traveller?.firstName?.charAt(0)}
                            </div>
                          </div>
                          <span className='d-flex flex-column text-capitalize fw-bolder fs-5'>
                            {`${traveller?.firstName} ${traveller?.lastName}`}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='card-body pt-0 pb-2 border-grey-200'>
                <div className="mb-3">
                  <span className="text-gray-600 min-w-125px w-125px d-inline-block">PAN number</span>
                  <span className="text-gray-900">{traveller?.pan?.panNumber || 'N/A'}</span>
                </div>
              </div>
            </div>
            {/* Vertical divider except after the last card in each row */}
            {idx % 2 === 0 && idx < data?.travellers?.length - 1 && (
              <div
                style={{
                  borderLeft: '1px solid #E5E5E5',
                  margin: '24px 0',
                  height: 'auto'
                }}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
